import React from "react";
import { Formik, Field, Form } from "formik";
import { Modal } from "seed/helpers";
import ExcelField from "components/util/helpers/ExcelField";
import l from "components/util/l";
import { ColumnTypes } from "components/collections/util/datatypes";
import ColumnField from "components/collections/forms/ColumnFormView.sub.field.view";
import PermissionForm from "components/collections/forms/PermissionForm";

const CollectionFormView = ({
  formRef,
  flow,
  collectionId,
  collectionType,
  error,
  isGenerated,
  isLoading,
  isLoadingGenerate,
  hidePermissions = false,
  hideTitle = false,
  initialColumns = [],
  initialPrimaryKey = null,
  showImport = false,
  collection = {},
  collections = [],
  isPermissionsShown,
  setIsPermissionsShown,
  setImportFile = () => { },
  onSubmit = () => { },
  onGenerate = () => { },
  onDelete = () => { },
}) => (
  <div className="card">

    {
      !hideTitle &&
        <div className="card-header">
          <h3 class="mb-0">
            {
              function(){
                if (collection.id) {
                  if (collectionType == "TABLE") return l("Editar tabla%CA019");
                  if (collectionType == "DOCUMENT") return l("Editar carpeta de archivos%CA020");
                  if (collectionType == "LIST") return l("Editar lista%CA021");
                }
                else {
                  if (collectionType == "TABLE") return l("Crear tabla%CA022");
                  if (collectionType == "DOCUMENT") return l("Crear carpeta de archivos%CA023");
                  if (collectionType == "LIST") return l("Crear lista%CA024");
                }
              }()
            }
          </h3>
        </div>
    }

    <div className="card-body px-4">

      <Formik
        innerRef={formRef}
        initialValues={{
          ...collection,
          name: collection?.uiSettings?.label ?? collection.name,
          selected_field: null,
          modified_pk: false,
          type: collectionType,
          structure: initialColumns,
          primary_key: initialPrimaryKey,
          settings: collection?.settings || {}
        }}
      >
        {({ values, setFieldValue }) =>
          <Form 
            id="collection-form"
            // autoComplete="off"
          >

            <div class="form-group mb-3">
              <span class="d-flex justify-content-between dropdown-header pt-0 pb-2 px-0">
                <span style={{ color: "#777" }}>{l("Nombre%GA074")}</span>
              </span>
              <div class="input-group">
                <Field
                  type="text"
                  name="name"
                  id="name"
                  placeholder={l("Ej. Empleados, Solicitudes, Productos%CA025")}
                  class="form-control"
                  autocomplete="off"
                  maxlength="512"
                  required={true}
                  autoFocus={true}
                />
              </div>
            </div>

            {
              !showImport && values.type == "TABLE"
                ? <div>
                  <span class="d-flex justify-content-between dropdown-header pt-1 pb-3 px-0">
                    <span style={{ color: "#777" }}>{l("Campos%CA026")}
                      {
                        !collection.id && values?.name?.length > 3 &&
                        <button
                          type="button"
                          class="btn btn-sm btn-link ml-1 px-2 mb-2 py-1 animate__animated animate__fadeIn animate__faster pt-2"
                          onClick={() => onGenerate(values?.name)}
                        >
                          {
                            isLoadingGenerate && <>
                              <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true" />
                              {l("Generando%CA027")}...
                            </>
                          }
                          {
                            !isLoadingGenerate && <>
                              <i class="tio-magic-wand mr-1"></i> {l("Sugerir campos%CA028")}
                            </>
                          }
                        </button>
                      }
                    </span>
                  </span>

                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th className="text-capitalize text-center">{l("Nombre%GA074")}</th>
                        <th className="text-capitalize text-center">{l("Tipo%GA079")}</th>
                        <th className="text-capitalize text-center"></th>
                        <th className="text-capitalize text-center"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        !isLoadingGenerate &&
                        <>
                          {
                            values?.structure?.sort((a, b) => {
                              if (a.action == "delete" || a.internal) return 1;
                              if (b.action == "delete" || b.internal) return -1;
                              return 0;
                            }).map((field, idx) => 
                              field.action != "delete" && !field.internal &&
                                <ColumnField
                                  key={idx}
                                  idx={idx}
                                  flow={flow}
                                  field={field}
                                  values={values}
                                  collections={collections}
                                  isGenerated={isGenerated}
                                  showMoveButtons={true}
                                  showDeleteButton={true}
                                  setFieldValue={setFieldValue}
                                />
                            )
                          }
                        </>
                      }
                    </tbody>
                    <tfoot>
                      <tr>
                        <td className="py-0" colSpan="4">
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-primary text-left btn-block mt-2 mb-2 px-3 w-auto"
                            onClick={() => {
                              setFieldValue("structure", [
                                ...values?.structure ?? [],
                                {
                                  initial: null,
                                  final: { 
                                    name: crypto.randomUUID().replace(/-/g, ''),
                                    label: "",
                                    type: ColumnTypes.STRING
                                  },
                                  action: "create",
                                  show_advanced: true
                                },
                              ]);
                              setFieldValue("selected_field", values?.structure?.length ?? 0);
                            }}
                          >
                            + {l("Nuevo campo%CA029")}
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                </div>
                : null
            }

            {!collection.id && showImport ?
              <div className="form-group px-3 pt-2 pb-4 mt-3" style={{ background: "#fafafa", border: "1px solid #f0f0f0" }}>
                <span class="d-flex justify-content-between dropdown-header pt-2 pb-2 px-0">
                  <span style={{ color: "#777" }}>{l("Crear desde excel%CA030")}</span>
                </span>
                <ExcelField
                  // ref={excelFileRef}
                  isSingleImport={true}
                  // onLoadFile={loadDataToValidate}
                />
              </div> : null}

            {
              !hidePermissions &&
                <div class="form-group mb-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm mt-1"
                    onClick={() => setIsPermissionsShown(!isPermissionsShown)}
                  >
                    <i class="tio-lock mr-1"></i> {l("Permisos%GA080")}
                  </button>
                </div>
            }

            {
              error &&
              <div class="alert alert-danger" role="alert">
                {error}
              </div>
            }

            <div className="d-flex justify-content-start">
              <button
                type="button"
                class="btn btn-block btn-primary mt-3 font-weight-bold"
                disabled={isLoading}
                onClick={() => {
                  let form = document.getElementById("collection-form")
                  if (form.checkValidity())
                    onSubmit(values)
                  else
                    form.reportValidity()
                }}
              >
                {
                  isLoading &&
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                }
                {
                  !isLoading && <>
                    {collection.id ? l("Guardar%GA023") : l("Crear%GA057")}
                  </>
                }
              </button>
              {
                collection.id &&
                  <button
                    type="button"
                    class="btn btn-outline-danger mt-3 ml-2 px-3"
                    onClick={onDelete}
                  >
                    {l("Eliminar%GA001")}
                  </button>
              }
            </div>

            {
              isPermissionsShown &&
                <Modal
                  flowId={flow.id}
                  collectionId={collectionId}
                  onClose={() => setIsPermissionsShown(false)}
                  initialValues={values.settings}
                  onParentSubmit={(_values) => {
                    setFieldValue("settings.permissions", _values.permissions);
                    setIsPermissionsShown(false);
                  }}
                  component={PermissionForm}
                />
            }

          </Form>}
      </Formik>
    </div>

  </div>
);

export default CollectionFormView;